import { Path } from '@/types/global';
import { FCRAWorkerAdverse } from '@/types/turn-api';

export const path = (path: Path<FCRAWorkerAdverse.ListDetails>) => path;
